import { classNamePrefix } from '../globals';

export function renderCheckbox (id: string, name: string, parentClass?: string) {
    const className = classNamePrefix + '-checkbox';

    const containerElement = document.createElement('div');
    containerElement.classList.add(className);

    if (parentClass) {
        containerElement.classList.add(parentClass);
    }

    const hiddenCheckboxElement = document.createElement('input');
    hiddenCheckboxElement.classList.add(className + '__hidden');
    hiddenCheckboxElement.id = id;
    hiddenCheckboxElement.type = 'checkbox';
    hiddenCheckboxElement.name = name;

    containerElement.appendChild(hiddenCheckboxElement);

    const visibleCheckboxElement = document.createElement('span');
    visibleCheckboxElement.classList.add(className + '__visible');

    containerElement.appendChild(visibleCheckboxElement);

    return containerElement;
}